import { observable, computed, makeObservable } from 'mobx';
import { get } from '@utils/get';
import ListStore from '@stores/list';

// ThreadStore：兼容 list 组件用法，提供统一的列表数据、状态、属性获取接口
export class ThreadStore {
    @observable namespace = 'thread';

    @observable threadList = null;  // 帖子列表
    @observable threadData = null; // 帖子详情数据
    @observable postList = null;    // 帖子评论列表
    @observable feedbackList = null;

    constructor(initData = {}) {
        this.threadData = initData?.thread || null;
        this.listStore = new ListStore();
        // 注册业务list
        this.listStore.registerList({ namespace: 'threadList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.threadList) {
            this.listStore.lists['threadList'].data = initData.threadList;
        }
        // 注册业务list
        this.listStore.registerList({ namespace: 'searchThreadList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.threadList) {
            this.listStore.lists['searchThreadList'].data = initData.threadList;
        }
        // 注册业务list
        this.listStore.registerList({ namespace: 'postList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.threadList) {
            this.listStore.lists['postList'].data = initData.postList;
        }

        // 注册业务list
        this.listStore.registerList({ namespace: 'feedbackList' });
        // 初始化数据（兼容 SSR/初始注入）
        if (initData.feedbackList) {
            this.listStore.lists['feedbackList'].data = initData.feedbackList;
        }
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get threadListData() {
        return this.listStore.getList({ namespace: 'threadList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get threadListAttribs() {
        return this.listStore.lists['threadList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get threadListLoading() {
        return this.listStore.lists['threadList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get threadListError() {
        return this.listStore.lists['threadList']?.requestError || { isError: false, errorText: '' };
    }


    /**
     * 获取搜索列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get searchThreadListData() {
        return this.listStore.getList({ namespace: 'searchThreadList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get searchThreadListAttribs() {
        return this.listStore.lists['searchThreadList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get searchThreadListLoading() {
        return this.listStore.lists['searchThreadList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get searchThreadListError() {
        return this.listStore.lists['searchThreadList']?.requestError || { isError: false, errorText: '' };
    }

    /**
     * 获取评论列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get postListData() {
        return this.listStore.getList({ namespace: 'postList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get postListAttribs() {
        return this.listStore.lists['postList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get postListLoading() {
        return this.listStore.lists['postList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get postListError() {
        return this.listStore.lists['postList']?.requestError || { isError: false, errorText: '' };
    }

    /**
     * 获取列表数据（拍平所有页，适合 list 组件直接渲染）
     */
    get feedbackListData() {
        return this.listStore.getList({ namespace: 'feedbackList' });
    }

    /**
     * 获取列表附加属性（如分页、总数等）
     */
    get feedbackListAttribs() {
        return this.listStore.lists['feedbackList']?.attribs || {};
    }

    /**
     * 获取 loading 状态
     */
    get feedbackListLoading() {
        return this.listStore.lists['feedbackList']?.loading || false;
    }

    /**
     * 获取错误信息
     */
    get feedbackListError() {
        return this.listStore.lists['feedbackList']?.requestError || { isError: false, errorText: '' };
    }
}

// 不再导出 threadStore 实例，全部用 threadAction 实例